import React from "react";

import classes from "./styles/style.module.css";
import CustomTextArea from "../../assets/components/CustomTextArea";

const TextAreaElement = ({
  id,
  req,
  title,
  subtitle,
  desc,
  placeholder,
  value,
  handleChange,
}) => {
  return (
    <div className="my-4">
      <div>
        <p className={classes.formTitle}>
          {title} <span className="text-danger">{req ? "*" : null}</span>
        </p>
      </div>
      <div className="px-2">
        {subtitle && <p className={classes.subTitle}>{subtitle}</p>}
        <CustomTextArea
          placeholder={placeholder}
          value={value}
          handleChange={(value) => handleChange(id, value)}
        />
        {desc && <p className={classes.desc}>{desc}</p>}
      </div>
    </div>
  );
};

export default TextAreaElement;
